import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/ParkGate/v4ward/car/list/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/ParkGate/v4ward/car/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/ParkGate/v4ward/car/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/ParkGate/v4ward/car/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/ParkGate/v4ward/car/submit/v2', params, options);
